// if (!customElements.get('product-recommendations')) {
//   class ProductRecommendations extends HTMLElement {
//     constructor() {
//       super();
//       this.slider = null;
//     }

//     connectedCallback() {
//       this.performRecommendations();
//     }

//     performRecommendations() {
//       const recommendations = this.querySelector(
//         '[data-recommendations]'
//       );
//       if (!recommendations) return;
//       fetch(this.dataset.url)
//         .then(response => response.text())
//         .then(text => {
//           const recommendationsHTML = new DOMParser()
//             .parseFromString(text, 'text/html')
//             .querySelector('[data-recommendations]')?.innerHTML;
//           if (!recommendationsHTML) return;
//           this.classList.remove('hidden');
//           var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
//           if(cartDrawerItemsFull) {
//             cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
//           }
//           recommendations.innerHTML = recommendationsHTML;
//           this.initSlider();

//           // initiate quick cart after fetch
//           // to activate trigger button events
//           setTimeout(() => {
//             if (document.querySelector("quick-cart-drawer")) {
//               document.querySelector("quick-cart-drawer").init();
//             } else {
//               // if quick-cart-drawer does not exists, remove trigger buttons
//               this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
//                 el?.remove();
//               })
//             }
//           }, 500);

//         });
//     }

//     initSlider() {
//       this.slider = new Swiper(this.querySelector('.swiper'), {
//         slidesPerView: 'auto',
//         spaceBetween: 16,
//       });
//     }
//   }

//   customElements.define('product-recommendations', ProductRecommendations);
// }
if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      if (this.dataset.manualRecommendations === 'true') {
        this.performManualRecommendations();
      } else {
        this.performRecommendations();
      }
    }

    performRecommendations() {
      const recommendations = this.querySelector('[data-recommendations]');

      if (!recommendations || !this.dataset.url) return;

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;

          if (!recommendationsHTML) return;

          recommendations.innerHTML = recommendationsHTML;

          this.showRecommendations();
        })
        .catch(error => {
          console.warn('Product recommendations failed:', error);
        });
    }

    performManualRecommendations() {
      const recommendations = this.querySelector('[data-recommendations]');

      if (!recommendations) return;

      const limit = Number(this.dataset.limit || 8);
      const slides = Array.from(recommendations.querySelectorAll('.swiper-slide'));

      if (!slides.length) return;

      const shuffledSlides = this.shuffle(slides);

      recommendations.innerHTML = '';

      shuffledSlides.slice(0, limit).forEach(slide => {
        recommendations.appendChild(slide);
      });

      this.showRecommendations();
    }

    showRecommendations() {
      this.classList.remove('hidden');

      const cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');

      if (cartDrawerItemsFull) {
        cartDrawerItemsFull.classList.remove('cart-drawer-items__full');
      }

      this.initSlider();
      this.initQuickCart();
    }

    shuffle(items) {
      const array = [...items];

      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }

      return array;
    }
initSlider() {
  const swiperEl = this.querySelector('.swiper');
  const wrapper = this.querySelector('.swiper-wrapper');
  const prevButton = this.querySelector('[data-product-recommendations-prev]');
  const nextButton = this.querySelector('[data-product-recommendations-next]');

  if (!swiperEl || !wrapper) return;

  if (this.slider && typeof this.slider.destroy === 'function') {
    this.slider.destroy(true, true);
    this.slider = null;
  }

  if (typeof Swiper !== 'undefined') {
    this.slider = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      watchOverflow: true
    });

    if (prevButton) {
      prevButton.onclick = event => {
        event.preventDefault();

        if (this.slider) {
          this.slider.slidePrev();
        }
      };
    }

    if (nextButton) {
      nextButton.onclick = event => {
        event.preventDefault();

        if (this.slider) {
          this.slider.slideNext();
        }
      };
    }

    return;
  }

  swiperEl.classList.add('product-recommendations__body--native-scroll');
  wrapper.classList.add('product-recommendations__items--native-scroll');

  const scrollAmount = () => {
    const firstSlide = wrapper.querySelector('.swiper-slide');
    if (!firstSlide) return 300;

    const slideWidth = firstSlide.getBoundingClientRect().width;
    return slideWidth + 16;
  };

  if (prevButton) {
    prevButton.onclick = event => {
      event.preventDefault();

      swiperEl.scrollBy({
        left: -scrollAmount(),
        behavior: 'smooth'
      });
    };
  }

  if (nextButton) {
    nextButton.onclick = event => {
      event.preventDefault();

      swiperEl.scrollBy({
        left: scrollAmount(),
        behavior: 'smooth'
      });
    };
  }
}
    // initSlider() {
    //   const swiperEl = this.querySelector('.swiper');
    //   const prevButton = this.querySelector('[data-product-recommendations-prev]');
    //   const nextButton = this.querySelector('[data-product-recommendations-next]');

    //   if (!swiperEl) return;

    //   if (typeof Swiper === 'undefined') {
    //     setTimeout(() => {
    //       this.initSlider();
    //     }, 300);

    //     return;
    //   }

    //   if (this.slider) {
    //     this.slider.destroy(true, true);
    //   }

    //   this.slider = new Swiper(swiperEl, {
    //     slidesPerView: 'auto',
    //     spaceBetween: 16,
    //     watchOverflow: true
    //   });

    //   if (prevButton) {
    //     prevButton.onclick = event => {
    //       event.preventDefault();

    //       if (this.slider) {
    //         this.slider.slidePrev();
    //       }
    //     };
    //   }

    //   if (nextButton) {
    //     nextButton.onclick = event => {
    //       event.preventDefault();

    //       if (this.slider) {
    //         this.slider.slideNext();
    //       }
    //     };
    //   }
    // }

    initQuickCart() {
      setTimeout(() => {
        const quickCartDrawer = document.querySelector('quick-cart-drawer');

        if (quickCartDrawer && typeof quickCartDrawer.init === 'function') {
          quickCartDrawer.init();
        } else {
          this.querySelectorAll('.quick-cart-drawer__trigger').forEach(el => {
            el?.remove();
          });
        }
      }, 300);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}